import { buildSequentialRouteStopsSavePayload, canBuildSequentialRouteStopsSavePayload } from './buildSequentialRouteStopsSavePayload';
import {
  buildRouteStopsSavePayload,
  type MainStopFormFields,
  type RouteStopSaveRow
} from './routeStopsSavePipeline';
import type { DeliveryGroupDraft } from './deliveryGroupTypes';
import { isSequentialStopsSaveModeEnabled } from './sequentialStopsSaveFlags';
import { logSequentialStopsSaveShadow } from './sequentialStopsSaveShadow';

export type ResolveRouteStopsSavePayloadResult = {
  rows: RouteStopSaveRow[];
  builder: 'legacy' | 'sequential' | 'sequential-fallback-legacy';
};

export function resolveRouteStopsSavePayload(params: {
  groups: DeliveryGroupDraft[];
  mainLoading: MainStopFormFields;
  mainUnloading: MainStopFormFields;
  routeId?: number;
}): ResolveRouteStopsSavePayloadResult {
  const legacyRows = buildRouteStopsSavePayload(params);

  if (!isSequentialStopsSaveModeEnabled()) {
    return { rows: legacyRows, builder: 'legacy' };
  }

  if (!canBuildSequentialRouteStopsSavePayload(params.groups)) {
    logSequentialStopsSaveShadow({
      routeId: params.routeId,
      legacyRows,
      sequentialRows: legacyRows,
      usedBuilder: 'sequential-fallback-legacy'
    });
    return { rows: legacyRows, builder: 'sequential-fallback-legacy' };
  }

  let sequentialRows: RouteStopSaveRow[];
  try {
    sequentialRows = buildSequentialRouteStopsSavePayload(params);
  } catch {
    logSequentialStopsSaveShadow({
      routeId: params.routeId,
      legacyRows,
      sequentialRows: legacyRows,
      usedBuilder: 'sequential-fallback-legacy'
    });
    return { rows: legacyRows, builder: 'sequential-fallback-legacy' };
  }

  logSequentialStopsSaveShadow({
    routeId: params.routeId,
    legacyRows,
    sequentialRows,
    usedBuilder: 'sequential'
  });

  return { rows: sequentialRows, builder: 'sequential' };
}
